<template>
  <div>
      <button @click="signOut">Sign out</button>
  </div>
</template>

<script>
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import store from '../store'

export default {
  data() {
    return {
    
    }
  },

  methods: {
    signOut() {
      
    }
  }


}
</script>

<style>

</style>